import { render } from "./WriteAssignment.vue?vue&type=template&id=69de0a2c"
import script from "./WriteAssignment.vue?vue&type=script&lang=js"
export * from "./WriteAssignment.vue?vue&type=script&lang=js"

import "./WriteAssignment.vue?vue&type=style&index=0&id=69de0a2c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__